import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=9e0268d2&scoped=true&"
import script from "./Students.vue?vue&type=script&lang=ts&"
export * from "./Students.vue?vue&type=script&lang=ts&"
import style0 from "./Students.vue?vue&type=style&index=0&id=9e0268d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0268d2",
  null
  
)

export default component.exports